import type { MerryButtonInteractionState } from "@/shared/ui/merryButtonVariants";

export const merryFunctionButtonVariants = [
  "logo",
  "account",
  "store",
] as const;

export type MerryFunctionButtonVariant =
  (typeof merryFunctionButtonVariants)[number];

export type MerryTopNavigationSessionType = "guest" | "authenticated";

const functionButtonNodeIds: Record<
  MerryFunctionButtonVariant,
  Record<MerryButtonInteractionState, string>
> = {
  account: {
    default: "300:31777",
    hovered: "300:31798",
    pressed: "300:31816",
  },
  logo: {
    default: "300:32192",
    hovered: "300:32226",
    pressed: "300:32238",
  },
  store: {
    default: "300:32041",
    hovered: "300:32135",
    pressed: "300:32157",
  },
};

const topNavigationNodeIds: Record<
  "default" | "context",
  Record<MerryTopNavigationSessionType, string>
> = {
  context: {
    authenticated: "351:58746",
    guest: "350:34897",
  },
  default: {
    authenticated: "299:31086",
    guest: "349:79989",
  },
};

export function getMerryFunctionButtonFigmaNodeId(
  variant: MerryFunctionButtonVariant,
  interactionState: MerryButtonInteractionState,
) {
  return functionButtonNodeIds[variant][interactionState];
}

export function getMerryTopNavigationFigmaNodeId(
  hasContext: boolean,
  sessionType: MerryTopNavigationSessionType,
) {
  return topNavigationNodeIds[hasContext ? "context" : "default"][
    sessionType
  ];
}
